import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import ParametersTableHeader from '../../Blocks/ParametersTableHeader';
import ParametersTypeValue from '../../Blocks/ParametersTypeValue';
import ReturnTypeValue from '../../Blocks/ReturnTypeValue';

function Vi(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="uploadfiletoftp">
                1.&nbsp;<span className="material-symbols-outlined">upload</span>&nbsp;{translate('uploadfiletoftp')}
            </Typography>
            <p><strong>{translate('uploadfiletoftp')}</strong> là hành động tải file lên FTP.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <div className='type-value'>
                                        <span className="material-symbols-outlined">title</span>
                                        <span>{translate('datatype__text')}</span>
                                    </div>
                                </td>
                                <td>Là nơi lưu trữ kết quả của hành động này.</td>
                                <td>$uploadFTPFile_1</td>
                            </tr>
                            <tr>
                                <td>{translate('providerid')}<span>*</span></td>
                                <td>
                                    <div className='type-value'>
                                        <span className="material-symbols-outlined">title</span>
                                        <span>{translate('datatype__text')}</span>
                                    </div>
                                </td>
                                <td>Là <strong>Provider ID</strong> của kết nối FTP. (xem <Box component={Link} to="/control-center/documentation/connections/ftp">tại đây</Box> để biết cách tạo kết nối).</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('filepath')}<span>*</span></td>
                                <td>
                                    <div className='type-value'>
                                        <span className="material-symbols-outlined">title</span>
                                        <span>{translate('datatype__text')}</span>
                                    </div>
                                </td>
                                <td>Là đường dẫn file bạn muốn upload.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('destinationdirectory')}</td>
                                <td>
                                    <div className='type-value'>
                                        <span className="material-symbols-outlined">title</span>
                                        <span>{translate('datatype__text')}</span>
                                    </div>
                                </td>
                                <td>Là đường dẫn của FTP nơi lưu trữ tệp đã tải lên.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="object" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$uploadFTPFile_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('providerid')}</span>
                            <div>ftp-1a2b3c4d5e6g7h</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filepath')}</span>
                            <div>/tmp/report.xlsx</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('destinationdirectory')}</span>
                            <div>ftp/reports</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        {
                                            "code": 226,
                                            "message": "226-File successfully transferred 226 1.238 seconds (measured here), 162.41 Kbytes per second"
                                        }, null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="downloadfilefromftp">
                2.&nbsp;<span className="material-symbols-outlined">download</span>&nbsp;{translate('downloadfilefromftp')}
            </Typography>
            <p><strong>{translate('downloadfilefromftp')}</strong> là hành động tải xuống một tệp từ FTP.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                        <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <div className='type-value'>
                                        <span className="material-symbols-outlined">title</span>
                                        <span>{translate('datatype__text')}</span>
                                    </div>
                                </td>
                                <td>Là nơi lưu trữ kết quả của hành động này.</td>
                                <td>$uploadFTPFile_1</td>
                            </tr>
                            <tr>
                                <td>{translate('providerid')}<span>*</span></td>
                                <td>
                                    <div className='type-value'>
                                        <span className="material-symbols-outlined">title</span>
                                        <span>{translate('datatype__text')}</span>
                                    </div>
                                </td>
                                <td>Là <strong>Provider ID</strong> của kết nối FTP. (xem <Box component={Link} to="/control-center/documentation/connections/ftp">tại đây</Box> để biết cách tạo kết nối).</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('filepath')}<span>*</span></td>
                                <td>
                                <div className='type-value'>
                                        <span className="material-symbols-outlined">title</span>
                                        <span>{translate('datatype__text')}</span>
                                    </div>
                                </td>
                                <td>Là đường dẫn của FTP lưu file cần tải về.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$downloadFtpFile_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('providerid')}</span>
                            <div>ftp-1a2b3c4d5e6g7h</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filepath')}</span>
                            <div>ftp/reports/report.xlsx</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>/tmp/downloads/sktwi174l9kzzqc2/20221025-003483/report.xlsx</div>
                        </div>
                    </div>
                </li>
            </ul>
        </Box>
    );
}
export default withTranslate(Vi);